export default {
  baseLayoutSubtitle: 'Dotyczy każdego raportu, chyba że raport nadpisuje ustawienie.',
};
